export enum CurrentWallApp {
    SpaceWall = 'SpaceWall',
    UsbWall = 'UsbWall',
    None = 'None'
}
